var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDepartmentTagTwoTone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M2.5643 3.75L1.7168 5.25L2.5643 6.75H4.1693L5.0168 5.25L4.1693 3.75H2.5643Z",
    fill: "#828282"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M6.32961 10.5L5.47461 12.015L6.31461 13.5H7.93461L8.77461 12.015L7.91961 10.5H6.32961Z",
    fill: "#999999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M7.91992 9L8.76742 7.5L7.91992 6H6.32992L5.48242 7.5L6.32992 9H7.91992Z",
    fill: "#999999"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M2.5643 8.25L1.7168 9.75L2.5643 11.25H4.1693L5.0168 9.75L4.1693 8.25H2.5643Z",
    fill: "#999999"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M10.0799 3.75L9.23242 5.25L10.0799 6.75H11.6849L12.5324 5.25L11.6849 3.75H10.0799Z",
    fill: "#999999"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M6.31461 1.5L5.47461 2.985L6.32961 4.5H7.91961L8.77461 2.985L7.93461 1.5H6.31461Z",
    fill: "#999999"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M10.0799 8.25L9.23242 9.75L10.0799 11.25H11.6849L12.5324 9.75L11.6849 8.25H10.0799Z",
    fill: "#999999"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 5.25L12.5625 2.25H10.08L8.8125 0H5.4375L4.17 2.25H1.6875L0 5.25L1.2675 7.5L0 9.75L1.6875 12.75H4.17L5.4375 15H8.8125L10.08 12.75H12.5625L14.25 9.75L12.9825 7.5L14.25 5.25ZM4.17 11.25H2.565L1.725 9.75L2.565 8.25H4.17L5.01 9.75L4.17 11.25ZM4.17 6.75H2.565L1.7175 5.25L2.5575 3.75H4.1625L5.0025 5.25L4.17 6.75ZM7.935 13.5H6.315L5.475 12.015L6.33 10.5H7.92L8.7675 12.015L7.935 13.5ZM5.4825 7.5L6.3225 6H7.9125L8.7525 7.5L7.9125 9H6.3225L5.4825 7.5ZM7.92 4.5H6.33L5.475 2.985L6.315 1.5H7.935L8.775 2.985L7.92 4.5ZM11.685 11.25H10.08L9.24 9.75L10.08 8.25H11.685L12.525 9.75L11.685 11.25ZM11.685 6.75H10.08L9.24 5.25L10.08 3.75H11.685L12.525 5.25L11.685 6.75Z",
    fill: "#999999"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartmentTagTwoTone);
export default __webpack_public_path__ + "static/media/department-tag-two-tone.6d7a2621d9e143559f7914836f7094fb.svg";
export { ForwardRef as ReactComponent };